// Libs
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// Utils
import { CloudStorage, platform } from 'components/AppConfig.json';
// Services
import { ApiServiceV2 } from 'services';
// Components
import {
	Wrapper,
	Popover,
	Spin,
	EyeIcon,
	SettingsIcon,
	Span,
	RefreshIcon,
	LogoIcon,
	Menu,
} from 'components';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Selectors
import { selectProfile } from 'screens/Login/selectors';

const OptionsMenu = ({
	isSpinning = false,
	defaultSelectKey = '',
	groupItems = [],
}) => {
	// TODO: CheckSelectDefault
	return isSpinning ? (
		<Spin spinning size='small' delay={50} tip={''} />
	) : (
		<Menu.Wrapper>
			{groupItems.map(group =>
				group.isSpinning && group.isSpinning ? (
					<Spin spinning size='small' delay={50} tip={''} />
				) : (
					<Menu.Group
						defaultSelectedKeys={defaultSelectKey}
						title={group.title}
					>
						{group.items.map(item =>
							item.isSpinning ? (
								<Spin spinning size='small' delay={50} tip={''} />
							) : (
								<Menu.Item
									disabled={item.disabled}
									onClick={() => item.onClick()}
									key={item.key}
								>
									{item.title}
								</Menu.Item>
							),
						)}
					</Menu.Group>
				),
			)}
		</Menu.Wrapper>
	);
};

const getReportUrl = ({ paymentId, profile }) => {
	const env = process.env.NODE_ENV;
	const organization = profile.organization.settings.photoStore.main;
	const company = profile.company.settings.photoStore.main;
	const entity_id = profile.entity.id;
	const reportUri = `${CloudStorage}/${platform}/${env}/${company}/${organization}/reports/payments/${entity_id}`;

	let reportId = `${paymentId}.pdf`;

	return `${reportUri}/${reportId}`;
};

const GetOptionsResumeContent = ({
	paymentId,
	profile,
	state,
	setState,
	paymentState,
	onExportExcel,
	paysLoaded,
}) => {
	const reportUrl = getReportUrl({ paymentId, profile });

	const handdleThen = (message, stateNameRefresh) => {
		sendToast({ message: message, type: 'success' });
		setState({ [stateNameRefresh]: false });
	};

	const handdleCatchError = (err, stateNameRefresh) => {
		sendToast({ message: err.message, type: err.type });
		setState({ [stateNameRefresh]: false });
	};

	const handdleGeneratePaymentPDF = () => {
		setState({ isRefreshPdf: true });

		ApiServiceV2.post({
			url: `/payments/generatePDF`,
			data: { paymentIds: [paymentId] },
		})
			.then(() => {
				handdleThen('PDF Generado', 'isRefreshPdf');
				setState({ isPdfGenered: true });
			})
			.catch(err => handdleCatchError(err, 'isRefreshPdf'));
	};

	const recordsHaveAllowedStates = (state, allowStates) =>
		!!allowStates.find(allowState => allowState === state);

	return (
		<OptionsMenu
			groupItems={[
				{
					title: 'Exportar',
					isSpinning: state.isRefreshPdf,
					items: [
						{
							title: `PDF Generar`,
							disabled: !recordsHaveAllowedStates(paymentState, [
								'released',
								'paid',
							]),
							onClick: handdleGeneratePaymentPDF,
							key: 'generatePDF',
						},
						{
							title: `PDF Abrir`,
							disabled:
								!recordsHaveAllowedStates(paymentState, ['released', 'paid']) ||
								!state.isPdfGenered,
							onClick: () => window.open(reportUrl),
							key: 'openPDF',
						},
						{
							title: 'Excel',
							disabled: !paysLoaded,
							onClick: onExportExcel,
							key: 'exportExcel',
						},
					],
				},
			]}
		/>
	);
};

const GetModeViewResumeContent = ({ generatingPDF, setMainState }) => (
	<OptionsMenu
		isSpinning={generatingPDF}
		groupItems={[
			{
				title: 'Producción',
				defaultSelectKey: 'individual',
				items: [
					{
						title: 'Individual',
						onClick: () => setMainState({ modeviewGroupOrders: false }),
						key: 'individual',
					},
					{
						title: 'Agrupadas',
						onClick: () => setMainState({ modeviewGroupOrders: true }),
						key: 'group',
					},
				],
			},
		]}
	/>
);

const HeaderSettings = ({
	paymentId,
	isPdfGenered,
	paymentState,
	setMainState,
	getResumePaycuts,
	isRefreshResumen,
	onExportExcel,
	paysLoaded,
}) => {
	const [state, _setState] = useState({
		isPdfGenered,
		isRefreshPdf: false,
	});
	const profile = useSelector(selectProfile);

	const setState = newState =>
		_setState(current => ({ ...current, ...newState }));

	return (
		<Wrapper width='95%' height='28px' justifyContent='space-between'>
			<Span fontSize='xl'>Resumen</Span>
			<Wrapper padding='0'>
				<Popover
					trigger='click'
					placement='bottomRight'
					title={null}
					content={
						<GetModeViewResumeContent
							generatingPDF={state.isRefreshPdf}
							setMainState={setMainState}
						/>
					}
				>
					<div>
						<EyeIcon button />
					</div>
				</Popover>

				<Popover
					trigger='click'
					placement='bottomRight'
					title={null}
					content={
						<GetOptionsResumeContent
							paymentId={paymentId}
							profile={profile}
							state={state}
							setState={setState}
							paymentState={paymentState}
							onExportExcel={onExportExcel}
							paysLoaded={paysLoaded}
						/>
					}
				>
					<div>
						<SettingsIcon />
					</div>
				</Popover>

				{isRefreshResumen ? (
					<LogoIcon button spin />
				) : (
					<RefreshIcon onClick={getResumePaycuts} />
				)}
			</Wrapper>
		</Wrapper>
	);
};

export default HeaderSettings;
